<div
  appDragDrop
  [disable]="disable"
  [default]="default"
  (onHover)="dragHover = true"
  (onUnhover)="dragHover = false"
  (onFileDropped)="fileDrop($event)"
  class="drag-container"
  #autoFillContainer
>
  @if (dragHover) {
    <div
      class="drag-drop-hover border-style-{{ borderStyle }} hover-style-{{ hoverStyle }}"
      [class.no-top-margin]="noTopMargin"
      [@dragHover]
      #container
    >
      @if (hoverStyle === 'white') {
        <app-sticky
          [offsetTop]="64"
          [minHeight]="320"
          [extraYSpacing]="20"
          [container]="container"
          [fullWidth]="true"
          [autoFill]="hoverStyle === 'white' ? autoFillContainer : undefined"
        >
          <div class="animation-container">
            <div class="animation">
              @if (darkBackground) {
                <img src="/assets/animations/upload-assets-dark.svg" alt="" />
              }
              @if (!darkBackground) {
                <img src="/assets/animations/upload-assets-light.svg" alt="" />
              }
            </div>
          </div>
        </app-sticky>
      } @else if (hoverStyle === 'replace') {
        <div class="animation-container no-bg">
          <div class="animation">
            <img src="/assets/animations/replace-assets.svg" alt="" />
          </div>
        </div>
      }
    </div>
  }
  <ng-content></ng-content>
</div>
